module.exports = __webpack_public_path__ + "a9f4d88a6aebf75f53c1078415a56a2e.jpg";